// Gamma Design System color tokens
const GAMMA = {
  green:       '#34d399',  // ems-green (emerald-400) — Online/Running
  greenDim:    '#059669',  // ems-green-dim (emerald-600)
  greenBright: '#6ee7b7',  // ems-green-bright (emerald-300)
  blue:        '#38bdf8',  // ems-blue (sky-400) — Charging
  amber:       '#fbbf24',  // ems-amber (amber-400) — Warning
  red:         '#fb7185',  // ems-red (rose-400) — Fault/Alarm
  redDeep:     '#e11d48',  // ems-red-deep (rose-600)
  textMuted:   '#64748b',  // ems-text-muted (slate-500) — Offline/Stopped
  textSecondary: '#94a3b8', // ems-text-secondary (slate-400) — Idle/Standby
} as const;

// Equipment color palette — aligned to Gamma Design System
export const SLD_COLORS = {
  generator: { stroke: GAMMA.green, fill: '#1e3a2f', text: GAMMA.green, textLight: GAMMA.greenBright },
  bess:      { stroke: '#06b6d4', fill: '#0c2d3d', text: '#06b6d4', textLight: '#67e8f9' },
  solar:     { stroke: '#eab308', fill: '#1a2e1a', text: '#eab308', textLight: '#fde047' },
  transformer: { stroke: '#a78bfa', fill: '#1a1a2e', text: '#a78bfa', textLight: '#c4b5fd' },
  breaker:   { closed: GAMMA.green, open: GAMMA.red, tripped: GAMMA.red },
  meter:     { stroke: GAMMA.amber, fill: '#2d2410', text: GAMMA.amber, textLight: GAMMA.amber },
  load:      { stroke: '#f97316', fill: '#2d1f0f', text: '#f97316', textLight: '#fdba74' },
  busBar:    { stroke: '#3b82f6', fill: '#1e3a5f', text: '#3b82f6' },
  evCharger: { stroke: '#8b5cf6', fill: '#1a2535', text: '#8b5cf6', textLight: '#c4b5fd' },
  offline:   { stroke: GAMMA.textMuted, fill: '#1e1e2e', text: GAMMA.textMuted },
  fault:     { stroke: GAMMA.red, fill: '#2d1010', text: GAMMA.red },
  stale:     { stroke: '#6b7280', fill: '#1f2937', text: '#6b7280' },

  // Status-specific palettes for generator nodes
  generatorOn:  { stroke: GAMMA.green, fill: '#132e22', text: GAMMA.green, textLight: GAMMA.greenBright },
  generatorOff: { stroke: GAMMA.textMuted, fill: '#1e1e2e', text: GAMMA.textMuted, textLight: '#94a3b8' },
  generatorFault: { stroke: GAMMA.red, fill: '#2d1010', text: GAMMA.red, textLight: '#fda4af' },

  // Status-specific palettes for BESS nodes
  bessCharging:    { stroke: GAMMA.blue, fill: '#0c2135', text: GAMMA.blue, textLight: '#7dd3fc' },
  bessDischarging: { stroke: GAMMA.green, fill: '#132e22', text: GAMMA.green, textLight: GAMMA.greenBright },
  bessIdle:        { stroke: GAMMA.textSecondary, fill: '#1a1e2e', text: GAMMA.textSecondary, textLight: '#cbd5e1' },
  bessFault:       { stroke: GAMMA.red, fill: '#2d1010', text: GAMMA.red, textLight: '#fda4af' },
} as const;

// Shared SVG filter for glow effect — rendered once by SLDSvgDefs in VerticalSLD
export const GLOW_FILTER_ID = 'sld-glow';

export function SLDSvgDefs() {
  return (
    <svg style={{ position: 'absolute', width: 0, height: 0 }}>
      <defs>
        <filter id={GLOW_FILTER_ID}>
          <feGaussianBlur stdDeviation="2" result="blur" />
          <feMerge>
            <feMergeNode in="blur" />
            <feMergeNode in="SourceGraphic" />
          </feMerge>
        </filter>
        <filter id="sld-glow-strong">
          <feGaussianBlur stdDeviation="4" result="blur" />
          <feMerge>
            <feMergeNode in="blur" />
            <feMergeNode in="SourceGraphic" />
          </feMerge>
        </filter>
      </defs>
    </svg>
  );
}
